import { h, render } from "preact";
import App from "./App";

render(<App />, document.getElementById("root"));
